import { render, staticRenderFns } from "./ConfigTicketApp.vue?vue&type=template&id=09976af3&scoped=true"
import script from "./ConfigTicketApp.vue?vue&type=script&lang=js"
export * from "./ConfigTicketApp.vue?vue&type=script&lang=js"
import style0 from "./ConfigTicketApp.vue?vue&type=style&index=0&id=09976af3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09976af3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09976af3')) {
      api.createRecord('09976af3', component.options)
    } else {
      api.reload('09976af3', component.options)
    }
    module.hot.accept("./ConfigTicketApp.vue?vue&type=template&id=09976af3&scoped=true", function () {
      api.rerender('09976af3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/templateApp/ConfigTicketApp.vue"
export default component.exports